import { ResponsiveImage } from 'approot/shared/images/imgix-responsive.constants';

export function getSmallestImage(imageUrls: ResponsiveImage[] | null) {
  return imageUrls?.at(0)?.urls.at(0)?.url || '';
}
